// Textele paginilor juridice (RO / RU / EN) și slug-urile rutele lor.
// Limba se ia din ruta :lang, identic cu mecanismul existent al site-ului.

export const legalText = {
  ro: {
    privacy: {
      title: "Politica de confidențialitate",
      short: "Politica de confidențialitate",
      lastUpdate: "Ultima actualizare: 25 august 2026",
      metaDescription:
        "Politica de confidențialitate a selik.md — cum prelucrăm datele cu caracter personal transmise prin formularul de contact.",
      sections: [
        {
          heading: "1. Cine suntem (identitatea operatorului)",
          paragraphs: [
            "Site-ul selik.md este administrat de S.R.L. „CAPS COFFEE”, IDNO 1015600029730, cu sediul juridic: MD-2072, mun. Chișinău, șos. Muncești 121, e-mail: sales@selik.md, telefon: +373 79 023 806. Societatea este operatorul datelor cu caracter personal prelucrate prin acest site, în sensul Legii nr. 195/2024 privind protecția datelor cu caracter personal.",
          ],
        },
        {
          heading: "2. Datele pe care le colectăm prin formularul „Contactează-ne”",
          paragraphs: [
            "Atunci când ne transmiteți o solicitare prin formularul de pe site, colectăm doar informațiile pe care ni le furnizați:",
          ],
          list: [
            "numele;",
            "adresa de e-mail;",
            "numărul de telefon;",
            "mesajul transmis;",
            "alte informații comunicate voluntar în mesaj.",
          ],
        },
        {
          heading: "3. Datele colectate automat",
          paragraphs: [
            "La accesarea site-ului pot fi colectate automat următoarele informații tehnice:",
          ],
          list: [
            "adresa IP;",
            "tipul dispozitivului și al browserului;",
            "limba utilizată;",
            "data și ora accesării;",
            "paginile vizitate;",
            "sursa accesării;",
            "acțiunile efectuate pe site;",
            "identificatori cookie și date analitice — numai după consimțământul dumneavoastră.",
          ],
        },
        {
          heading: "4. Scopurile prelucrării",
          paragraphs: ["Datele furnizate prin formular și datele colectate automat sunt prelucrate în următoarele scopuri:"],
          list: [
            "primirea și examinarea solicitării dumneavoastră;",
            "contactarea persoanei care a transmis solicitarea;",
            "oferirea răspunsului sau a informațiilor solicitate;",
            "comunicarea referitoare la solicitarea transmisă;",
            "funcționarea și securitatea site-ului;",
            "prevenirea abuzurilor și a mesajelor spam;",
            "analizarea traficului și îmbunătățirea site-ului — numai după acceptarea cookie-urilor analitice;",
            "respectarea obligațiilor legale.",
          ],
        },
        {
          heading: "5. Temeiurile prelucrării",
          list: [
            "solicitarea transmisă de utilizator și demersurile necesare pentru a-i răspunde;",
            "consimțământul pentru Google Analytics și pentru cookie-urile opționale;",
            "interesul legitim privind securitatea și buna funcționare a site-ului;",
            "obligațiile legale ale companiei.",
          ],
        },
        {
          heading: "6. Contactarea utilizatorului",
          paragraphs: [
            "S.R.L. „CAPS COFFEE” poate contacta persoana care a transmis o solicitare, prin telefon sau prin e-mail, pentru examinarea solicitării și pentru continuarea comunicării referitoare la mesajul transmis.",
            "Trimiterea formularului nu reprezintă un consimțământ automat pentru newslettere, promoții generale sau campanii publicitare ulterioare.",
          ],
        },
        {
          heading: "7. Google Analytics",
          paragraphs: [
            "Site-ul utilizează Google Analytics (identificator G-9J655207BR), un serviciu de analiză web oferit de Google, numai după consimțământul dumneavoastră exprimat prin bannerul de cookie-uri. Înainte de alegerea dumneavoastră, serviciul nu este încărcat.",
            "Google Analytics poate colecta informații despre dispozitiv, browser, adresa IP, paginile vizitate, durata vizitei și modul de utilizare a site-ului. Prelucrarea de către Google poate avea loc în afara Republicii Moldova sau a Spațiului Economic European. Dacă nu acceptați cookie-urile analitice, site-ul rămâne complet funcțional.",
          ],
        },
        {
          heading: "8. Destinatarii datelor",
          paragraphs: [
            "Datele dumneavoastră pot fi accesate de:",
          ],
          list: [
            "angajații și colaboratorii autorizați ai operatorului;",
            "furnizorul de hosting și de mentenanță;",
            "furnizorii de e-mail și comunicații;",
            "Google — numai după acceptarea cookie-urilor analitice;",
            "autoritățile publice, dacă transmiterea este impusă de lege.",
          ],
          paragraphs2: [
            "Datele utilizatorilor nu sunt vândute și nu sunt utilizate în scopuri publicitare de către terți.",
          ],
        },
        {
          heading: "9. Transferuri internaționale",
          paragraphs: [
            "Google și alți furnizori internaționali pot prelucra date în alte state, în conformitate cu mecanismele de protecție pe care le aplică. Serviciile analitice neesențiale sunt activate numai după consimțământul dumneavoastră.",
          ],
        },
        {
          heading: "10. Durata păstrării datelor",
          list: [
            "solicitările primite prin formular: atât timp cât sunt necesare pentru examinare și comunicare, de regulă maximum 24 de luni de la ultima comunicare;",
            "datele pot fi păstrate mai mult dacă există o obligație legală, o reclamație, un litigiu sau necesitatea apărării unui drept;",
            "datele cookie se păstrează conform duratei proprii a cookie-urilor și alegerii utilizatorului.",
          ],
        },
        {
          heading: "11. Drepturile persoanei vizate",
          paragraphs: [
            "În condițiile Legii nr. 195/2024 privind protecția datelor cu caracter personal, aveți următoarele drepturi:",
          ],
          list: [
            "dreptul la informare;",
            "dreptul de acces;",
            "dreptul la rectificare;",
            "dreptul la ștergere („dreptul de a fi uitat”);",
            "dreptul la restricționarea prelucrării;",
            "dreptul la opoziție;",
            "dreptul la portabilitatea datelor, când este aplicabilă;",
            "dreptul de a vă retrage consimțământul în orice moment;",
            "dreptul de a depune o plângere la Centrul Național pentru Protecția Datelor cu Caracter Personal;",
            "dreptul de a vă adresa în instanța de judecată.",
          ],
          paragraphs2: [
            "Solicitările privind datele cu caracter personal se trimit la adresa de e-mail: sales@selik.md.",
          ],
        },
        {
          heading: "12. Securitatea datelor",
          paragraphs: [
            "Aplicăm măsuri tehnice și organizatorice adecvate pentru protejarea datelor cu caracter personal împotriva accesului neautorizat, pierderii sau modificării. Formularul de contact folosește măsuri de protecție împotriva mesajelor spam și a utilizării abuzive.",
          ],
        },
        {
          heading: "13. Linkuri externe",
          paragraphs: [
            "Site-ul poate conține linkuri către pagini externe (de exemplu, rețele sociale). Nu suntem responsabili pentru practicile de prelucrare a datelor ale acestor terți; vă recomandăm să consultați politicile lor de confidențialitate.",
          ],
        },
        {
          heading: "14. Modificarea politicii",
          paragraphs: [
            "Prezenta politică poate fi actualizată periodic. Versiunea actuală este publicată întotdeauna pe această pagină, împreună cu data ultimei actualizări.",
          ],
        },
        {
          heading: "15. Date de contact",
          paragraphs: [
            "S.R.L. „CAPS COFFEE”, IDNO 1015600029730, MD-2072, mun. Chișinău, șos. Muncești 121. E-mail: sales@selik.md. Telefon: +373 79 023 806.",
          ],
        },
      ],
    },
    terms: {
      title: "Termeni și condiții",
      short: "Termeni și condiții",
      lastUpdate: "Ultima actualizare: 25 august 2026",
      metaDescription:
        "Termenii și condițiile de utilizare a site-ului de prezentare selik.md.",
      sections: [
        {
          heading: "1. Operatorul site-ului",
          paragraphs: [
            "Site-ul selik.md este administrat de S.R.L. „CAPS COFFEE”, IDNO 1015600029730, cu sediul juridic: MD-2072, mun. Chișinău, șos. Muncești 121. E-mail: sales@selik.md. Telefon: +373 79 023 806.",
          ],
        },
        {
          heading: "2. Despre site",
          paragraphs: [
            "selik.md este un site de prezentare a produselor sub marca SELIK. Site-ul nu este un magazin online: prin intermediul lui nu se efectuează comenzi, nu se realizează plăți și nu se încheie contracte.",
          ],
        },
        {
          heading: "3. Informațiile despre produse",
          paragraphs: [
            "Informațiile despre produse publicate pe site au caracter informativ și pot fi modificate sau actualizate fără o notificare prealabilă.",
          ],
        },
        {
          heading: "4. Formularul „Contactează-ne”",
          paragraphs: [
            "Prin formularul de pe site puteți transmite o solicitare privind produsele sau activitatea noastră. Pentru examinarea solicitării vă rugăm să furnizați datele solicitate în formular (nume, e-mail, telefon și mesaj).",
          ],
        },
        {
          heading: "5. Efectul trimiterii formularului",
          paragraphs: [
            "Trimiterea formularului nu reprezintă o comandă, nu implică plăți și nu duce la încheierea unui contract. Transmiterea formularului are ca unic efect transmiterea unei solicitări către operator.",
          ],
        },
        {
          heading: "6. Contactarea utilizatorului",
          paragraphs: [
            "S.R.L. „CAPS COFFEE” poate contacta utilizatorul, prin telefon sau e-mail, în legătură cu solicitarea transmisă.",
          ],
        },
        {
          heading: "7. Documentele aplicabile",
          paragraphs: [
            "Utilizarea site-ului este supusă, de asemenea, Politicii de confidențialitate și Politicii privind cookie-urile, publicate pe acest site.",
          ],
        },
        {
          heading: "8. Actualizarea documentelor",
          paragraphs: [
            "Acești termeni pot fi actualizați periodic. Versiunea actuală este publicată întotdeauna pe această pagină.",
          ],
        },
      ],
    },
    cookies: {
      title: "Politica privind cookie-urile",
      short: "Politica privind cookie-urile",
      lastUpdate: "Ultima actualizare: 25 august 2026",
      metaDescription:
        "Politica privind cookie-urile site-ului selik.md — cookie-uri necesare și cookie-uri analitice, activate numai după consimțământ.",
      sections: [
        {
          heading: "1. Ce sunt cookie-urile",
          paragraphs: [
            "Cookie-urile sunt fișiere mici de text stocate pe dispozitivul dumneavoastră atunci când vizitați un site. Ele permit site-ului să-și amintească anumite informații despre vizită, cum ar fi preferințele sau alegerile exprimate.",
          ],
        },
        {
          heading: "2. Cookie-uri strict necesare",
          paragraphs: [
            "Aceste cookie-uri sunt indispensabile pentru funcționarea site-ului și nu pot fi dezactivate. Pe site-ul nostru, acestea includ memorarea alegerii dumneavoastră privind cookie-urile (cheia „selik_cookie_consent”) și măsurile tehnice de securitate a formularului de contact. Ele nu sunt folosite în scopuri de urmărire.",
          ],
        },
        {
          heading: "3. Cookie-uri analitice",
          paragraphs: [
            "Cookie-urile analitice ne ajută să înțelegem cum este utilizat site-ul, pentru a-l îmbunătăți. Acestea sunt activate numai după consimțământul dumneavoastră exprimat prin bannerul de cookie-uri.",
          ],
        },
        {
          heading: "4. Google Analytics",
          paragraphs: [
            "Pentru analiza traficului folosim serviciul Google Analytics, identificator G-9J655207BR, furnizat de Google. Google Analytics este încărcat și activat numai după acceptarea cookie-urilor analitice; înainte de alegerea dumneavoastră nu se încarcă și nu colectează date. Serviciul poate crea cookie-uri precum _ga și _gid și poate prelucra date în alte state.",
          ],
        },
        {
          heading: "5. Utilizarea site-ului fără cookie-uri analitice",
          paragraphs: [
            "Puteți utiliza site-ul doar cu tehnologiile strict necesare: toate funcțiile, inclusiv formularul de contact, funcționează și fără Google Analytics.",
          ],
        },
        {
          heading: "6. Cum puteți modifica alegerea",
          paragraphs: [
            "Alegerea poate fi modificată oricând prin linkul „Setări cookie” din subsolul site-ului. Trecerea de la „Accept” la „Doar necesare” dezactivează imediat Google Analytics și șterge cookie-urile de analiză cunoscute, în măsura în care acest lucru este posibil tehnic.",
          ],
        },
        {
          heading: "7. Durata păstrării preferinței",
          paragraphs: [
            "Alegerea dumneavoastră este memorată pentru 180 de zile. După expirarea acestei perioade, bannerul va fi afișat din nou.",
          ],
        },
        {
          heading: "8. Operatorul datelor",
          paragraphs: [
            "S.R.L. „CAPS COFFEE”, IDNO 1015600029730, MD-2072, mun. Chișinău, șos. Muncești 121. E-mail: sales@selik.md. Telefon: +373 79 023 806.",
          ],
        },
        {
          heading: "9. Data ultimei actualizări",
          paragraphs: ["Ultima actualizare: 25 august 2026."],
        },
      ],
    },
  },
  ru: {
    privacy: {
      title: "Политика конфиденциальности",
      short: "Политика конфиденциальности",
      lastUpdate: "Последнее обновление: 25 августа 2026",
      metaDescription:
        "Политика конфиденциальности selik.md — как обрабатываются персональные данные, передаваемые через форму обратной связи.",
      sections: [
        {
          heading: "1. Кто мы (сведения об операторе)",
          paragraphs: [
            "Сайт selik.md администрируется ООО „CAPS COFFEE” (S.R.L. „CAPS COFFEE”), IDNO 1015600029730, юридический адрес: MD-2072, мун. Кишинёв, шос. Мунчешть 121, e-mail: sales@selik.md, телефон: +373 79 023 806. Компания является оператором персональных данных, обрабатываемых через этот сайт, в значении Закона № 195/2024 о защите персональных данных.",
          ],
        },
        {
          heading: "2. Данные, собираемые через форму «Свяжитесь с нами»",
          paragraphs: [
            "Когда вы отправляете запрос через форму на сайте, мы собираем только те сведения, которые вы нам предоставляете:",
          ],
          list: [
            "имя;",
            "адрес электронной почты;",
            "номер телефона;",
            "сообщение;",
            "иные сведения, добровольно сообщённые в сообщении.",
          ],
        },
        {
          heading: "3. Данные, собираемые автоматически",
          paragraphs: ["При доступе к сайту могут автоматически собираться следующие технические сведения:"],
          list: [
            "IP-адрес;",
            "тип устройства и браузера;",
            "используемый язык;",
            "дата и время доступа;",
            "посещённые страницы;",
            "источник перехода;",
            "действия, совершённые на сайте;",
            "идентификаторы cookie и аналитические данные — только после вашего согласия.",
          ],
        },
        {
          heading: "4. Цели обработки",
          paragraphs: ["Данные, переданные через форму, и данные, собираемые автоматически, обрабатываются в следующих целях:"],
          list: [
            "получение и рассмотрение вашего запроса;",
            "связь с лицом, направившим запрос;",
            "предоставление ответа или запрошенной информации;",
            "коммуникация по переданному запросу;",
            "функционирование и безопасность сайта;",
            "предотвращение злоупотреблений и спам-сообщений;",
            "анализ трафика и улучшение сайта — только после принятия аналитических cookie;",
            "соблюдение требований законодательства.",
          ],
        },
        {
          heading: "5. Правовые основания обработки",
          list: [
            "запрос, направленный пользователем, и шаги, необходимые для ответа на него;",
            "согласие на использование Google Analytics и необязательных cookie;",
            "законный интерес в обеспечении безопасности и функционирования сайта;",
            "юридические обязательства компании.",
          ],
        },
        {
          heading: "6. Связь с пользователем",
          paragraphs: [
            "ООО „CAPS COFFEE” может связаться с лицом, направившим запрос, по телефону или по электронной почте для рассмотрения запроса и продолжения общения по переданному сообщению.",
            "Отправка формы не означает автоматическое согласие на рассылки, общие рекламные акции или последующие рекламные кампании.",
          ],
        },
        {
          heading: "7. Google Analytics",
          paragraphs: [
            "Сайт использует Google Analytics (идентификатор G-9J655207BR) — сервис веб-аналитики компании Google — только после вашего согласия, выраженного через баннер cookie. До вашего выбора сервис не загружается.",
            "Google Analytics может собирать сведения об устройстве, браузере, IP-адресе, посещённых страницах, продолжительности визита и способах использования сайта. Обработка данных компанией Google может осуществляться за пределами Республики Молдова или Европейской экономической зоны. Если вы не принимаете аналитические cookie, сайт остаётся полностью функциональным.",
          ],
        },
        {
          heading: "8. Получатели данных",
          paragraphs: ["Доступ к вашим данным могут иметь:"],
          list: [
            "уполномоченные сотрудники и партнёры оператора;",
            "поставщик хостинга и технического обслуживания;",
            "поставщики услуг электронной почты и связи;",
            "Google — только после принятия аналитических cookie;",
            "государственные органы, если передача предусмотрена законом.",
          ],
          paragraphs2: [
            "Данные пользователей не продаются и не используются третьими лицами в рекламных целях.",
          ],
        },
        {
          heading: "9. Международная передача данных",
          paragraphs: [
            "Google и другие международные поставщики могут обрабатывать данные в других государствах в соответствии с применяемыми ими механизмами защиты. Необязательные аналитические сервисы активируются только после вашего согласия.",
          ],
        },
        {
          heading: "10. Срок хранения данных",
          list: [
            "запросы, полученные через форму: столько, сколько необходимо для их рассмотрения и переписки, как правило не более 24 месяцев с момента последней коммуникации;",
            "данные могут храниться дольше при наличии юридической обязанности, жалобы, спора или необходимости защиты права;",
            "данные cookie хранятся в соответствии со сроком действия самих cookie и выбором пользователя.",
          ],
        },
        {
          heading: "11. Права субъекта данных",
          paragraphs: [
            "В соответствии с Законом № 195/2024 о защите персональных данных вы имеете следующие права:",
          ],
          list: [
            "право на информацию;",
            "право на доступ;",
            "право на исправление;",
            "право на удаление («право быть забытым»);",
            "право на ограничение обработки;",
            "право на возражение;",
            "право на переносимость данных, когда оно применимо;",
            "право отозвать согласие в любой момент;",
            "право подать жалобу в Национальный центр по защите персональных данных;",
            "право обратиться в суд.",
          ],
          paragraphs2: [
            "Запросы, касающиеся персональных данных, направляются на адрес электронной почты: sales@selik.md.",
          ],
        },
        {
          heading: "12. Безопасность данных",
          paragraphs: [
            "Мы применяем надлежащие технические и организационные меры для защиты персональных данных от несанкционированного доступа, утраты или изменения. Форма обратной связи использует средства защиты от спама и злоупотреблений.",
          ],
        },
        {
          heading: "13. Внешние ссылки",
          paragraphs: [
            "Сайт может содержать ссылки на внешние страницы (например, социальные сети). Мы не несём ответственности за практику обработки данных такими третьими лицами; рекомендуем ознакомиться с их политиками конфиденциальности.",
          ],
        },
        {
          heading: "14. Изменение политики",
          paragraphs: [
            "Настоящая политика может периодически обновляться. Актуальная версия всегда публикуется на этой странице вместе с датой последнего обновления.",
          ],
        },
        {
          heading: "15. Контактные данные",
          paragraphs: [
            "ООО „CAPS COFFEE”, IDNO 1015600029730, MD-2072, мун. Кишинёв, шос. Мунчешть 121. E-mail: sales@selik.md. Телефон: +373 79 023 806.",
          ],
        },
      ],
    },
    terms: {
      title: "Условия использования",
      short: "Условия использования",
      lastUpdate: "Последнее обновление: 25 августа 2026",
      metaDescription: "Условия использования сайта-визитки selik.md.",
      sections: [
        {
          heading: "1. Оператор сайта",
          paragraphs: [
            "Сайт selik.md администрируется ООО „CAPS COFFEE”, IDNO 1015600029730, юридический адрес: MD-2072, мун. Кишинёв, шос. Мунчешть 121. E-mail: sales@selik.md. Телефон: +373 79 023 806.",
          ],
        },
        {
          heading: "2. О сайте",
          paragraphs: [
            "selik.md — это сайт-визитка продукции под брендом SELIK. Сайт не является интернет-магазином: через него не оформляются заказы, не производятся платежи и не заключаются договоры.",
          ],
        },
        {
          heading: "3. Информация о продукции",
          paragraphs: [
            "Информация о продукции, размещённая на сайте, носит ознакомительный характер и может изменяться или обновляться без предварительного уведомления.",
          ],
        },
        {
          heading: "4. Форма «Свяжитесь с нами»",
          paragraphs: [
            "Через форму на сайте вы можете направить запрос о нашей продукции или деятельности. Для рассмотрения запроса просим указать данные, запрашиваемые в форме (имя, e-mail, телефон и сообщение).",
          ],
        },
        {
          heading: "5. Последствия отправки формы",
          paragraphs: [
            "Отправка формы не является заказом, не предполагает платежей и не приводит к заключению договора. Единственным последствием отправки формы является передача запроса оператору.",
          ],
        },
        {
          heading: "6. Связь с пользователем",
          paragraphs: [
            "ООО „CAPS COFFEE” может связаться с пользователем по телефону или по электронной почте в связи с направленным запросом.",
          ],
        },
        {
          heading: "7. Применимые документы",
          paragraphs: [
            "Использование сайта также регулируется Политикой конфиденциальности и Политикой использования файлов cookie, опубликованными на этом сайте.",
          ],
        },
        {
          heading: "8. Обновление документов",
          paragraphs: [
            "Настоящие условия могут периодически обновляться. Актуальная версия всегда публикуется на этой странице.",
          ],
        },
      ],
    },
    cookies: {
      title: "Политика использования файлов cookie",
      short: "Политика использования файлов cookie",
      lastUpdate: "Последнее обновление: 25 августа 2026",
      metaDescription:
        "Политика использования файлов cookie сайта selik.md — необходимые и аналитические cookie, активируемые только после согласия.",
      sections: [
        {
          heading: "1. Что такое cookie",
          paragraphs: [
            "Файлы cookie — это небольшие текстовые файлы, сохраняемые на вашем устройстве при посещении сайта. Они позволяют сайту запоминать определённые сведения о визите, например ваши предпочтения или сделанный выбор.",
          ],
        },
        {
          heading: "2. Строго необходимые cookie",
          paragraphs: [
            "Эти cookie необходимы для работы сайта и не могут быть отключены. На нашем сайте к ним относится запоминание вашего выбора в отношении cookie (ключ «selik_cookie_consent») и технические меры безопасности формы обратной связи. Они не используются для отслеживания.",
          ],
        },
        {
          heading: "3. Аналитические cookie",
          paragraphs: [
            "Аналитические cookie помогают нам понять, как используется сайт, чтобы улучшать его. Они активируются только после вашего согласия, выраженного через баннер cookie.",
          ],
        },
        {
          heading: "4. Google Analytics",
          paragraphs: [
            "Для анализа трафика мы используем сервис Google Analytics (идентификатор G-9J655207BR), предоставляемый компанией Google. Google Analytics загружается и активируется только после принятия аналитических cookie; до вашего выбора он не загружается и не собирает данные. Сервис может создавать cookie, такие как _ga и _gid, и обрабатывать данные в других государствах.",
          ],
        },
        {
          heading: "5. Использование сайта без аналитических cookie",
          paragraphs: [
            "Вы можете пользоваться сайтом только со строго необходимыми технологиями: все функции, включая форму обратной связи, работают и без Google Analytics.",
          ],
        },
        {
          heading: "6. Как изменить свой выбор",
          paragraphs: [
            "Выбор можно изменить в любой момент по ссылке «Настройки cookie» в нижней части сайта. Переход от «Принять» к «Только необходимые» немедленно отключает Google Analytics и удаляет известные аналитические cookie, насколько это технически возможно.",
          ],
        },
        {
          heading: "7. Срок хранения предпочтения",
          paragraphs: [
            "Ваш выбор сохраняется в течение 180 дней. По истечении этого срока баннер будет показан снова.",
          ],
        },
        {
          heading: "8. Оператор данных",
          paragraphs: [
            "ООО „CAPS COFFEE”, IDNO 1015600029730, MD-2072, мун. Кишинёв, шос. Мунчешть 121. E-mail: sales@selik.md. Телефон: +373 79 023 806.",
          ],
        },
        {
          heading: "9. Дата последнего обновления",
          paragraphs: ["Последнее обновление: 25 августа 2026."],
        },
      ],
    },
  },
  en: {
    privacy: {
      title: "Privacy Policy",
      short: "Privacy Policy",
      lastUpdate: "Last updated: 25 August 2026",
      metaDescription:
        "Privacy Policy of selik.md — how we process personal data submitted through the contact form.",
      sections: [
        {
          heading: "1. Who we are (identity of the operator)",
          paragraphs: [
            "The website selik.md is operated by S.R.L. „CAPS COFFEE”, IDNO 1015600029730, legal address: MD-2072, mun. Chișinău, șos. Muncești 121, e-mail: sales@selik.md, phone: +373 79 023 806. The company is the controller of personal data processed through this website, within the meaning of Law no. 195/2024 on personal data protection.",
          ],
        },
        {
          heading: "2. Data collected through the “Contact us” form",
          paragraphs: [
            "When you send a request through the form on the website, we collect only the information you provide to us:",
          ],
          list: [
            "your name;",
            "your e-mail address;",
            "your phone number;",
            "your message;",
            "any other information voluntarily provided in the message.",
          ],
        },
        {
          heading: "3. Data collected automatically",
          paragraphs: [
            "When you access the website, the following technical information may be collected automatically:",
          ],
          list: [
            "IP address;",
            "device and browser type;",
            "language used;",
            "date and time of access;",
            "pages visited;",
            "traffic source;",
            "actions performed on the website;",
            "cookie identifiers and analytics data — only after your consent.",
          ],
        },
        {
          heading: "4. Purposes of processing",
          paragraphs: ["The data provided through the form and the data collected automatically are processed for the following purposes:"],
          list: [
            "receiving and reviewing your request;",
            "contacting the person who submitted the request;",
            "providing the requested answer or information;",
            "communicating about the submitted request;",
            "the operation and security of the website;",
            "preventing abuse and spam messages;",
            "analysing traffic and improving the website — only after accepting analytics cookies;",
            "compliance with legal obligations.",
          ],
        },
        {
          heading: "5. Legal bases for processing",
          list: [
            "the request submitted by the user and the steps necessary to answer it;",
            "consent for Google Analytics and optional cookies;",
            "the legitimate interest in the security and operation of the website;",
            "the company's legal obligations.",
          ],
        },
        {
          heading: "6. Contacting the user",
          paragraphs: [
            "S.R.L. „CAPS COFFEE” may contact the person who submitted a request, by phone or e-mail, in order to review the request and continue the communication regarding the submitted message.",
            "Submitting the form does not constitute automatic consent to newsletters, general promotions or subsequent advertising campaigns.",
          ],
        },
        {
          heading: "7. Google Analytics",
          paragraphs: [
            "The website uses Google Analytics (identifier G-9J655207BR), a web analytics service provided by Google, only after your consent expressed through the cookie banner. Before your choice, the service is not loaded.",
            "Google Analytics may collect information about the device, browser, IP address, pages visited, visit duration and how the website is used. Processing by Google may take place outside the Republic of Moldova or the European Economic Area. If you do not accept analytics cookies, the website remains fully functional.",
          ],
        },
        {
          heading: "8. Recipients of the data",
          paragraphs: ["Your data may be accessed by:"],
          list: [
            "authorised employees and collaborators of the operator;",
            "the hosting and maintenance provider;",
            "e-mail and communication providers;",
            "Google — only after accepting analytics cookies;",
            "public authorities, where disclosure is required by law.",
          ],
          paragraphs2: [
            "Users' data are not sold and are not used for advertising purposes by third parties.",
          ],
        },
        {
          heading: "9. International transfers",
          paragraphs: [
            "Google and other international providers may process data in other countries, in accordance with the protection mechanisms they apply. Non-essential analytics services are activated only after your consent.",
          ],
        },
        {
          heading: "10. Data retention",
          list: [
            "requests received through the form: for as long as necessary to review them and communicate, generally no more than 24 months after the last communication;",
            "data may be kept longer if there is a legal obligation, a complaint, a dispute or the need to defend a right;",
            "cookie data are kept according to the duration of the cookies themselves and the user's choice.",
          ],
        },
        {
          heading: "11. Rights of the data subject",
          paragraphs: [
            "Under Law no. 195/2024 on personal data protection, you have the following rights:",
          ],
          list: [
            "the right to information;",
            "the right of access;",
            "the right to rectification;",
            "the right to erasure (“right to be forgotten”);",
            "the right to restriction of processing;",
            "the right to object;",
            "the right to data portability, where applicable;",
            "the right to withdraw your consent at any time;",
            "the right to lodge a complaint with the National Centre for Personal Data Protection;",
            "the right to address the courts.",
          ],
          paragraphs2: [
            "Requests regarding personal data should be sent to: sales@selik.md.",
          ],
        },
        {
          heading: "12. Data security",
          paragraphs: [
            "We apply appropriate technical and organisational measures to protect personal data against unauthorised access, loss or alteration. The contact form uses protection measures against spam and abusive use.",
          ],
        },
        {
          heading: "13. External links",
          paragraphs: [
            "The website may contain links to external pages (e.g. social networks). We are not responsible for the data processing practices of these third parties; we recommend that you consult their privacy policies.",
          ],
        },
        {
          heading: "14. Changes to this policy",
          paragraphs: [
            "This policy may be updated from time to time. The current version is always published on this page, together with the date of the last update.",
          ],
        },
        {
          heading: "15. Contact details",
          paragraphs: [
            "S.R.L. „CAPS COFFEE”, IDNO 1015600029730, MD-2072, mun. Chișinău, șos. Muncești 121. E-mail: sales@selik.md. Phone: +373 79 023 806.",
          ],
        },
      ],
    },
    terms: {
      title: "Terms and Conditions",
      short: "Terms and Conditions",
      lastUpdate: "Last updated: 25 August 2026",
      metaDescription: "Terms and Conditions for the use of the selik.md presentation website.",
      sections: [
        {
          heading: "1. Website operator",
          paragraphs: [
            "The website selik.md is operated by S.R.L. „CAPS COFFEE”, IDNO 1015600029730, legal address: MD-2072, mun. Chișinău, șos. Muncești 121. E-mail: sales@selik.md. Phone: +373 79 023 806.",
          ],
        },
        {
          heading: "2. About the website",
          paragraphs: [
            "selik.md is a presentation website for products under the SELIK brand. The website is not an online store: no orders are placed, no payments are made and no contracts are concluded through it.",
          ],
        },
        {
          heading: "3. Product information",
          paragraphs: [
            "The product information published on the website is provided for information purposes and may be changed or updated without prior notice.",
          ],
        },
        {
          heading: "4. The “Contact us” form",
          paragraphs: [
            "Through the form on the website you can submit a request regarding our products or activity. In order to review your request, please provide the details requested in the form (name, e-mail, phone and message).",
          ],
        },
        {
          heading: "5. Effect of submitting the form",
          paragraphs: [
            "Submitting the form does not constitute an order, does not involve payments and does not lead to the conclusion of a contract. The sole effect of submitting the form is the transmission of a request to the operator.",
          ],
        },
        {
          heading: "6. Contacting the user",
          paragraphs: [
            "S.R.L. „CAPS COFFEE” may contact the user, by phone or e-mail, in connection with the request submitted.",
          ],
        },
        {
          heading: "7. Applicable documents",
          paragraphs: [
            "The use of the website is also governed by the Privacy Policy and the Cookie Policy published on this website.",
          ],
        },
        {
          heading: "8. Document updates",
          paragraphs: [
            "These terms may be updated from time to time. The current version is always published on this page.",
          ],
        },
      ],
    },
    cookies: {
      title: "Cookie Policy",
      short: "Cookie Policy",
      lastUpdate: "Last updated: 25 August 2026",
      metaDescription:
        "Cookie Policy of selik.md — necessary cookies and analytics cookies, activated only after consent.",
      sections: [
        {
          heading: "1. What cookies are",
          paragraphs: [
            "Cookies are small text files stored on your device when you visit a website. They allow the website to remember certain information about the visit, such as your preferences or the choices you have made.",
          ],
        },
        {
          heading: "2. Strictly necessary cookies",
          paragraphs: [
            "These cookies are essential for the operation of the website and cannot be disabled. On our website, they include the storage of your cookie choice (the key “selik_cookie_consent”) and the technical security measures of the contact form. They are not used for tracking purposes.",
          ],
        },
        {
          heading: "3. Analytics cookies",
          paragraphs: [
            "Analytics cookies help us understand how the website is used, so that we can improve it. They are activated only after your consent expressed through the cookie banner.",
          ],
        },
        {
          heading: "4. Google Analytics",
          paragraphs: [
            "For traffic analysis we use the Google Analytics service, identifier G-9J655207BR, provided by Google. Google Analytics is loaded and activated only after accepting analytics cookies; before your choice it does not load and does not collect data. The service may create cookies such as _ga and _gid and may process data in other countries.",
          ],
        },
        {
          heading: "5. Using the website without analytics cookies",
          paragraphs: [
            "You can use the website with strictly necessary technologies only: all features, including the contact form, work without Google Analytics.",
          ],
        },
        {
          heading: "6. How to change your choice",
          paragraphs: [
            "Your choice can be changed at any time via the “Cookie Settings” link in the website footer. Switching from “Accept” to “Necessary only” immediately disables Google Analytics and deletes the known analytics cookies, to the extent technically possible.",
          ],
        },
        {
          heading: "7. How long the preference is kept",
          paragraphs: [
            "Your choice is stored for 180 days. After this period expires, the banner will be shown again.",
          ],
        },
        {
          heading: "8. Data operator",
          paragraphs: [
            "S.R.L. „CAPS COFFEE”, IDNO 1015600029730, MD-2072, mun. Chișinău, șos. Muncești 121. E-mail: sales@selik.md. Phone: +373 79 023 806.",
          ],
        },
        {
          heading: "9. Last updated",
          paragraphs: ["Last updated: 25 August 2026."],
        },
      ],
    },
  },
};

// Slug-urile rutei pentru fiecare pagină juridică și limbă
export const legalSlugs = {
  ro: {
    privacy: "politica-de-confidentialitate",
    terms: "termeni-si-conditii",
    cookies: "politica-cookie",
  },
  ru: {
    privacy: "politika-konfidentsialnosti",
    terms: "usloviya-ispolzovaniya",
    cookies: "politika-cookie",
  },
  en: {
    privacy: "privacy-policy",
    terms: "terms-and-conditions",
    cookies: "cookie-policy",
  },
};

// Construiește calea completă a unei pagini juridice pentru limba dată
export function legalPath(lang, type) {
  const l = legalSlugs[lang] ? lang : "ro";
  return `/${l}/${legalSlugs[l][type]}`;
}

// Etichetele din footer (se schimbă odată cu limba)
export const footerLegal = {
  ro: {
    title: "Documente",
    privacy: "Politica de confidențialitate",
    terms: "Termeni și condiții",
    cookies: "Politica privind cookie-urile",
    settings: "Setări cookie",
  },
  ru: {
    title: "Документы",
    privacy: "Политика конфиденциальности",
    terms: "Условия использования",
    cookies: "Политика использования файлов cookie",
    settings: "Настройки cookie",
  },
  en: {
    title: "Documents",
    privacy: "Privacy Policy",
    terms: "Terms and Conditions",
    cookies: "Cookie Policy",
    settings: "Cookie Settings",
  },
};
